import React from 'react'

import { Card, Loading } from '~/components'

import Styled from './final-transshipment.styled'
import useHooks from './final-transshipment.hooks'

import { ReportFilter, ReportTable } from './components'

const FinalTransshipment = () => {
  const { data, methods } = useHooks()

  const height = window.innerHeight - 240 > 455 ? window.innerHeight - 240 : 455

  return (
    <Styled.Container>
      <Card>
        <Styled.HeaderWrapper>
          <Styled.Header>FINAL COAL TRANSSHIPMENT</Styled.Header>
          <ReportFilter
            data={{
              filter: data.filter,
              isExporting: data.isExporting,
            }}
            methods={{
              handleYearChange: methods.handleYearChange,
              handleMonthChange: methods.handleMonthChange,
              handleExportReport: methods.handleExportReport,
              handleLocationChange: methods.handleLocationChange,
            }}
          />
        </Styled.HeaderWrapper>

        {data.isLoading && (
          <Styled.LoadingContainer height={height}>
            <Loading />
          </Styled.LoadingContainer>
        )}

        {!data.isLoading && data.dataTable.data_final_transshipment !== null && (
          <Styled.TableContainer height={height}>
            <ReportTable data={data.dataTable} />
          </Styled.TableContainer>
        )}

        {!data.isLoading && data.dataTable.data_final_transshipment === null && (
          <Styled.EmptyRecordContainer height={height}>
            <Styled.EmptyRecordText>No final transshipment records available.</Styled.EmptyRecordText>
          </Styled.EmptyRecordContainer>
        )}
      </Card>
    </Styled.Container>
  )
}

FinalTransshipment.propTypes = {}

export default FinalTransshipment
